import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import DateRangeDescription from "./DateRangeDescription";
import ConsignmentDueWarningIcon from "./ConsignmentDueWarningIcon";
const ConsignmentDeliveryDate = ({ consignment }) => {
    if (!consignment || !consignment.deliveryFrom) {
        return null;
    }
    const deliveryTo = ("revisedDeliveryTo" in consignment && consignment.revisedDeliveryTo)
        ? consignment.revisedDeliveryTo
        : consignment.deliveryTo;
    if (!deliveryTo) {
        return null;
    }
    return (_jsxs("span", { children: [_jsx(ConsignmentDueWarningIcon, { consignment: consignment }), _jsx(DateRangeDescription, { fromISOTimestamp: consignment.deliveryFrom, toISOTimestamp: deliveryTo })] }));
};
export default ConsignmentDeliveryDate;
